import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { UserTie } from '../../../../components/icons/Icons.js';

const Personal = ({ data }) => {
    return <Row>
        <Col sm="6" className='mt-4'>
            <div className="employee-app">
                <Card className="employee-card position-relative overflow-hidden">
                    <Card.Header className="d-flex align-items-center justify-content-start gap-2">
                        <div className="employee-bullet">
                               <UserTie class_name="text-purple" />
                        </div>
                        <div className="employee-title text-purple">Personal Details</div>
                    </Card.Header>
                    <Card.Body className="">
                        <Row className="gy-4">
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">DOB:</div>
                                        <div className="employee-value">{data.dob || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="employee-label">Gender:</div>
                                        <div className="employee-value">{data.gender || "-"}</div>
                                    </div>


                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Blood Group:</div>
                                        <div className="employee-value">{data.blood_group || "-"}</div>
                                    </div>

                                    <div>
                                        <div className="employee-label">Marital Status:</div>
                                        <div className="employee-value">{data.marital_status || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </Col>

        {/* <Col sm="6" className='mt-4'>
            <div className="employee-app">
                <Card className="employee-card position-relative overflow-hidden">
                    <Card.Header className="d-flex align-items-center justify-content-start gap-2">
                        <div className="employee-bullet">
                            <Clock />
                        </div>
                        <div className="employee-title text-purple">Work Details</div>
                    </Card.Header>
                    <Card.Body className="">
                        <Row className="gy-4">
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Shift:</div>
                                        <div className="employee-value">{data.shift || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="employee-label">DOJ:</div>
                                        <div className="employee-value">{data.date_of_join || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Attendance Cycle::</div>
                                        <div className="employee-value">{data.attendance_cycle || "-"}</div>
                                    </div>
                                    <div className="employee-branch">
                                        <div className="employee-label">TDS Status::</div>
                                        <div className="employee-value">{data.tds_status || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </Col> */}
    </Row>
}

export default Personal